import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-asset-list-header',
  templateUrl: './asset-list-header.component.html',
  styleUrls: ['./asset-list-header.component.scss'],
  standalone: false,
})
export class AssetListHeaderComponent {
  dropdownOpen: boolean = false;

  @Input() title: string = '';
  @Input() addNewText: string = '';
  @Input() hideAddNew: boolean = false;
  @Input() hideDropdown: boolean = false;
  @Output() addNewClicked = new EventEmitter<void>();

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  onAddNewClick() {
    this.addNewClicked.emit();
  }

  onUploadClick() {}
}
